import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setScrolledDown } from "components/feature/app/actions";

const useScrolledDown = () => {
  const dispatch = useDispatch();

  const { isScrolledDown } = useSelector((s) => s.app);

  useEffect(() => {
    const listener = (e) => {
      const { scrollY } = window;

      if (!isScrolledDown && scrollY > 1) {
        dispatch(setScrolledDown(true));
      }

      if (isScrolledDown && scrollY < 1) {
        dispatch(setScrolledDown(false));
      }
    };

    window.addEventListener("scroll", listener);
    return () => {
      window.removeEventListener("scroll", listener);
    };
  }, [isScrolledDown]);

  return [isScrolledDown];
};

export default useScrolledDown;
